'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';
import { getBrowserMemory, removeLegacyPendingApplicationId } from './_helpers/application-browser-memory';
type WaitlistSignupContextValue = {
  isOpen: boolean;
  openKey: number;
  productInterest: string | null;
  open: (productInterest?: string) => void;
  close: () => void;
  isCurrentOpening: (openKey: number) => boolean;
};
const WaitlistSignupContext = createContext<WaitlistSignupContextValue | null>(null);
export function WaitlistSignupProvider(t0) {
  const $ = _c(10);
  const {
    children
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [openKey, setOpenKey] = useState(0);
  const [productInterest, setProductInterest] = useState(null);
  const latestOpenKey = useRef(0);
  const activeOpenKey = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = interest => {
      const memory = getBrowserMemory();
      if (memory) {
        removeLegacyPendingApplicationId(memory);
      }
      const nextOpenKey = latestOpenKey.current + 1;
      latestOpenKey.current = nextOpenKey;
      activeOpenKey.current = nextOpenKey;
      setProductInterest(interest ?? null);
      setOpenKey(nextOpenKey);
      setIsOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const open = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      activeOpenKey.current = null;
      setIsOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const close = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = candidateOpenKey => activeOpenKey.current === candidateOpenKey;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const isCurrentOpening = t3;
  let t4;
  if ($[3] !== isOpen || $[4] !== openKey || $[5] !== productInterest) {
    t4 = {
      isOpen,
      openKey,
      productInterest,
      open,
      close,
      isCurrentOpening
    };
    $[3] = isOpen;
    $[4] = openKey;
    $[5] = productInterest;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const value = t4;
  let t5;
  if ($[7] !== children || $[8] !== value) {
    t5 = <WaitlistSignupContext.Provider value={value}>{children}</WaitlistSignupContext.Provider>;
    $[7] = children;
    $[8] = value;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
export function useWaitlistSignupOptional() {
  return useContext(WaitlistSignupContext);
}
export function useWaitlistSignup() {
  const ctx = useContext(WaitlistSignupContext);
  if (!ctx) {
    throw new Error("useWaitlistSignup must be used within WaitlistSignupProvider");
  }
  return ctx;
}